export const getReservedFileTagValues = () => ([
  'filename', 'file_extension', 'file_folder_path', 'fileid', 'projectid', 'filecontent',
  'filecreationyear', 'filecreationmonth', 'filecreationday', 'filecreationhour', 'filecreationminute', 'filecreationsecond',
  'filemodificationyear', 'filemodificationmonth', 'filemodificationday', 'filemodificationhour', 'filemodificationminute', 'filemodificationsecond'
]);

export const buildReservedTagSet = (systemTagsEvent = [], systemTagsGlobal = []) => {
  const systemValues = [...systemTagsEvent, ...systemTagsGlobal]
    .map(tag => (tag?.value || '').toLowerCase())
    .filter(Boolean);
  return new Set([
    ...getReservedFileTagValues(),
    ...systemValues
  ]);
};

export const getSafeTagVariable = (value, reservedSet) => {
  const baseValue = (value || '').trim();
  if (!baseValue) return '';

  const normalizedReserved = reservedSet
    ? new Set([...reservedSet].map(val => (val || '').toLowerCase()))
    : new Set();
  let candidate = baseValue;
  let counter = 1;

  while (normalizedReserved.has(candidate.toLowerCase())) {
    candidate = `${baseValue}${counter}`;
    counter += 1;
  }

  return candidate;
};

export const RESERVED_USER_TAG_VARIABLE_SUFFIXES = [
  '_reason',
  '_coordinates',
  '_confidence',
  '_confidence_source',
  '_needs_review',
  '_review_reason'
];

export const hasUserTagVariableReservedChars = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  return /\s/.test(normalized)
    || RESERVED_USER_TAG_VARIABLE_SUFFIXES.some((suffix) => normalized.endsWith(suffix));
};

const getTagVariable = (tag) => {
  const value = tag?.variable ?? tag?.value ?? tag?.key ?? tag?.name ?? tag?.label ?? tag;
  return typeof value === 'string' ? value.trim().toLowerCase() : '';
};

export const findCrossScopeTagValues = (tags = [], eventTags = []) => {
  const sourcesByValue = new Map();
  const addSource = (tag, source) => {
    const value = getTagVariable(tag);
    if (!value) return;
    if (!sourcesByValue.has(value)) {
      sourcesByValue.set(value, new Set());
    }
    sourcesByValue.get(value).add(source);
  };

  tags.forEach((tag) => addSource(tag, tag?.tag_type === 'widget' ? 'widget' : 'event'));
  eventTags.forEach((tag) => addSource(tag, 'event'));

  return new Set(
    [...sourcesByValue.entries()]
      .filter(([, sources]) => sources.has('widget') && sources.has('event'))
      .map(([value]) => value)
  );
};
